import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: 'share',
    loadChildren: () => import('./share-links/public/public-share-links.module').then(m => m.PublicShareLinksModule)
  },
  {
    path: '',
    loadChildren: () => import('./main/main.module').then(m => m.MainModule)
  },
  {
    path: 'errors',
    loadChildren: () => import('./errors/errors.module').then(m => m.ErrorsModule)
  },
  {
    path: 'signin',
    loadChildren: () => import('./auth/components/signin/signin.module').then(m => m.SigninModule)
  }, {
    path: 'reset-password',
    loadChildren: () => import('./auth/components/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  }, {
    path: 'forgot-password',
    loadChildren: () => import('./auth/components/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'report-file',
    loadChildren: () => import('./report-file/report-file.module').then(m => m.ReportFileModule)
  },
  {
    path: '',
    redirectTo: '/vehicles',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload'})
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRoutingModule { }
